/* eslint-disable react/require-default-props */
/* eslint-disable react/no-danger */
import React, { useState } from 'react';
import { createMonitoreBidding, destroyMonitoredBidding } from 'services/actions/monitore_actions';
import { useSelector } from 'react-redux';
import tabId from 'services/tabId';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import createTrack from 'services/actions/tracker_actions';
import { track } from 'services/tracking';
import { BiddingData, MonitoredBy } from 'store/modules/bidding_store/types';
import { BulletinBiddingsTypes } from 'store/modules/bulletins_store/types';
import iconUserBlue from 'assets/images/user-icon-blue.svg';
import SquareLoader from '../square_loader';
import { LoadingMonitoreButton, Container } from './styles';

interface MonitoreButtonProps {
  bidding?: BiddingData | BulletinBiddingsTypes;
  biddingId: number;
  isMonitored: boolean;
  source: string;
}

const MonitoreButton = (props: MonitoreButtonProps) => {
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const { bidding, biddingId, isMonitored, source } = props;
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const isCurrentUserMonitoring =
    bidding?.monitors?.some((m) => m.user_id === profile.id) ?? isMonitored;
  const [monitored, setMonitored] = useState<boolean>(isCurrentUserMonitoring);
  const [monitors, setMonitors] = useState<Array<MonitoredBy>>(bidding?.monitors ?? []);

  const formatNames = (names: string[]) => {
    if (names.length === 0) return '';
    if (names.length === 1) return names[0];
    if (names.length === 2) return `${names[0]} e ${names[1]}`;

    return `${names.slice(0, -1).join(', ')} e ${names[names.length - 1]}`;
  };

  const namesArray = monitors?.map((m) => m.name) || [];
  const names = formatNames(namesArray) || 'Nenhum membro do time gerenciando essa licitação';

  return (
    <Container>
      <button
        type="button"
        onClick={() => {
          if (monitored) {
            destroyMonitoredBidding({
              biddingId,
              setIsLoading,
              setMonitored,
              companyId: profile?.representant
                ? profile?.currentCompany[tabId()]
                : profile.clientId,
            });
            setMonitors((prev) => prev.filter((m) => m.user_id !== profile.id));
            createTrack('Card - Desativou o monitoramento', { fonte: source });
          } else if (!isLoading) {
            createMonitoreBidding({
              biddingId,
              setIsLoading,
              setMonitored,
              companyId: profile?.representant
                ? profile?.currentCompany[tabId()]
                : profile.clientId,
            });
            setMonitors((prev) => {
              const alreadyExists = prev.some((m) => m.user_id === profile.id);
              if (alreadyExists) return prev;

              return [...prev, { user_id: profile.id, name: profile.name }];
            });
            createTrack('Card - Ativou o monitoramento', { fonte: source });
            track('monitoramento.ativou_monitoramento', { fonte: source, bidding_id: biddingId });
          }
        }}
        className={
          monitored
            ? 'btn btn-sm btn-secondary mr-1 mb-1 mt-md-0 d-flex align-items-center'
            : 'btn btn-sm btn-primary tour-monitoring-add-btn mr-1 mb-1 mt-md-0 d-flex align-items-center'
        }
      >
        {monitored ? 'Desativar' : 'Ativar'} monitoramento de chat
        {monitors?.length !== 0 && (
          <div
            className="databalloon monitors d-flex ml-2"
            data-balloon-length="medium"
            aria-label={`Gerenciado por: ${names}`}
          >
            <img className="icon-user" src={iconUserBlue} alt="icone de usuário" />
            <span className="monitors-length">{monitors?.length}</span>
          </div>
        )}
        <LoadingMonitoreButton
          className={`position-relative ${isLoading ? 'd-inline-block' : 'd-none'}`}
        >
          <SquareLoader customClass="monitoring-button" />
        </LoadingMonitoreButton>
      </button>
    </Container>
  );
};

export default MonitoreButton;
